<template>
  <el-dialog
    title="已收到发票"
    :visible.sync="dialogVisible"
    width="620px"
    append-to-body
    @closed="reset"
  >
    <el-form label-width="130px">
      <el-form-item label="发票接收方式">
        <el-radio-group v-model="receiveType">
          <el-radio :label="1">已收到纸质发票</el-radio>
          <el-radio :label="2">上传电子发票</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="receiveType === 2" label="电子发票">
        <file-upload v-model="invoiceUrls" multiple />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">
        确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateOfflineBusinessOrder } from "@/api/offline-business-order";
import FileUpload from "./FileUpload.vue";

export default {
  name: "OfflineBusinessInvoiceDialog",
  components: { FileUpload },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    return {
      receiveType: 1,
      invoiceUrls: [],
      submitting: false
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    }
  },
  methods: {
    reset() {
      this.receiveType = 1;
      this.invoiceUrls = [];
    },
    async submit() {
      if (this.receiveType === 2 && !this.invoiceUrls.length) {
        this.$message.warning("请上传电子发票");
        return;
      }
      this.submitting = true;
      try {
        const res = await updateOfflineBusinessOrder({
          id: Number(this.orderId),
          invoice_url: this.receiveType === 2 ? this.invoiceUrls : [],
          is_invoice_received: true
        });
        if (!res) return;
        this.$message.success("发票状态更新成功");
        this.dialogVisible = false;
        this.$emit("success");
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>
